import Record from "./base"
import randomString from "../../utils/random-string"

export class Screen extends Record {
  constructor(...props) {
    super(...props)
    const [model, data] = props
    const rdmStr = randomString()
    this.name = rdmStr
    this.id = rdmStr
  }
}



// WEBPACK FOOTER //
// ./src/store/serializers/screen.js